import React from 'react';
import { Link } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

const GetUrl = (input) => {
  if (
    input.startsWith('http://') ||
    input.startsWith('https://') ||
    input.startsWith('tel:') ||
    input.startsWith('sms:') ||
    input.startsWith('//') ||
    input.startsWith('#') ||
    input.startsWith('/')
  ) {
    return input;
  }

  return '/' + input;
};

const LinkWrap = (props) => {
  let linkTo = '#';

  if (props.to && typeof props.to !== 'string') {
    linkTo = GetUrl(props.to.cached_url);
  } else if (props.to && typeof props.to === 'string') {
    linkTo = GetUrl(props.to);
  }

  if (linkTo === '/home') {
    linkTo = '/';
  }

  if (linkTo.startsWith('/_LANDING_PAGE_')) {
    linkTo = linkTo.replace('/_LANDING_PAGE_', '');
  }

  const handleClickWrap = (evt) => {
    if (
      evt.currentTarget &&
      evt.currentTarget.attributes &&
      evt.currentTarget.attributes.hasOwnProperty('href') &&
      evt.currentTarget.attributes.href.value &&
      evt.currentTarget.attributes.href.value.startsWith('#')
    ) {
      const targetId = evt.currentTarget.attributes.href.value.substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        const headerOffset = 150;
        const targetPosition = targetElement.getBoundingClientRect().top;

        const isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;

        if (isSmoothScrollSupported) {
          window.scrollBy({
            top: targetPosition - headerOffset,
            behavior: 'smooth',
          });
        } else {
          window.scrollBy(0, targetPosition - headerOffset);
        }

        evt.preventDefault();
      }
    }

    if (props.handleClick) {
      return props.handleClick(evt);
    }
  };

  if (linkTo.startsWith('/') && !linkTo.startsWith('//')) {
    return (
      <Link to={linkTo} onClick={handleClickWrap} style={props.style}>
        {props.children}
      </Link>
    );
  } else {
    if (props.openInNewWindow) {
      return (
        <OutboundLink href={linkTo} onClick={handleClickWrap} target="_blank" style={props.style}>
          {props.children}
        </OutboundLink>
      );
    } else {
      return (
        <OutboundLink href={linkTo} onClick={handleClickWrap} style={props.style}>
          {props.children}
        </OutboundLink>
      );
    }
  }
};

export default LinkWrap;
